export const QUERY_PARAM_KEY_ZOOM = 'zoom'
export const QUERY_PARAM_KEY_POSITION_X = 'posX'
export const QUERY_PARAM_KEY_POSITION_Y = 'posY'
export const QUERY_PARAM_KEY_POSITION_Z = 'posZ'
export const QUERY_PARAM_KEY_LAYERS = 'layers'
export const QUERY_PARAM_KEY_FREE_SELECTIONS = 'selections'
export const QUERY_PARAM_KEY_HIERARCHICAL_SELECTIONS = 'hierarchicalSelections'
export const QUERY_PARAM_KEY_UNSUPERVISED_SELECTIONS = 'unsupervisedSelections'
export const QUERY_PARAM_KEY_RETURN_URL = 'returnUrl'
